import { render, staticRenderFns } from "./second-body.vue?vue&type=template&id=20f5e002&"
import script from "./second-body.vue?vue&type=script&lang=js&"
export * from "./second-body.vue?vue&type=script&lang=js&"
import style0 from "./second-body.vue?vue&type=style&index=0&id=20f5e002&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports